import React from "react";
import { variablesGlobales } from "../../configs/variables";

export const Primary = (props) => {
  const isPayWompi = props.isPaymentWompi;

  if (props.href) {
    return (
      <div>
        <a
          href={props.href}
          aria-label={props["aria-label"]}
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-hidden"
          style={{ cursor: "pointer" }}
        >
          <div className="flex">
            {props.text}
            <div className="grid content-center pl-2">{props.icon}</div>
          </div>
        </a>
      </div>
    );
  }

  return (
    <div>
      {isPayWompi ? (
        <a
          href={`${
            variablesGlobales.urlServiceBackend
          }/api/v1/wompi/checkout?value1=${btoa(props.doc)}&value2=${btoa(
            props.credit_id,
          )}&value3=${btoa(props.amount)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            type="button"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs text-xl text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-hidden"
            style={{ cursor: "pointer" }}
          >
            <div className="flex">
              {props.text}
              <div className="grid content-center pl-2">{props.icon}</div>
            </div>
          </button>
        </a>
      ) : (
        <button
          type="submit"
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-hidden"
          style={{ cursor: "pointer" }}
        >
          <div className="flex">
            {props.text}
            <div className="grid content-center pl-2">{props.icon}</div>
          </div>
        </button>
      )}
    </div>
  );
};
